// Centralized filter lists for the UsersList page

export const userFilters = [
  { label: 'الكل', value: 'all' },
  { label: 'نشط', value: 'active' },
  { label: 'غير نشط', value: 'inactive' },
  { label: 'مدير عام', value: 'super_admin' },
  { label: 'تاجر', value: 'merchant' },
];
